
import React from "react";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";

function SelexORACLE() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
      }}
    >
      {/* Main website navbar */}
      <div
        style={{
          position: "relative",
          zIndex: 1000,
          flexShrink: 0,
          width: "100%",
        }}
      >
        <SelexSolNavbar
          isLoggedIn={!!sessionStorage.getItem("usertoken")}
        />
      </div>

      {/* SelexORACLE application */}
      <iframe
        id="selexOracleFrame"
        name="selexOracleFrame"
        src="/SelexORACLE/index.html"
        title="SelexORACLE"
        style={{
          display: "block",
          width: "100%",
          flex: 1,
          minHeight: 0,
          border: "none",
        }}
      />
    </div>
  );
}

export default SelexORACLE;
